import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Set the browser tab title as early as possible
document.title = 'Pair2 Move';
// Inject the Pair2 logo as the favicon at runtime
const FAVICON_URL = 'https://cdn.magicpatterns.com/uploads/vjCe9SCWtj4zo85MkTgr7J/Pair2_(2).svg';
const ensureFavicon = (rel: string) => {
  let link = document.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement('link');
    link.rel = rel;
    document.head.appendChild(link);
  }
  link.type = 'image/svg+xml';
  link.href = FAVICON_URL;
};
ensureFavicon('icon');
ensureFavicon('shortcut icon');
ensureFavicon('apple-touch-icon');
render(<App data-id="element-701" />, document.getElementById('root'));